import { View } from '../CommonTypes';
import useViews from '../hooks/useViews';

export const SolarSceneSelect = ({
  currentView,
  setSelectedView,
}: {
  currentView: View | null;
  setSelectedView: (view: View) => void;
}) => {
  const [views] = useViews();

  return (
    <div className="z-2 absolute left-0 top-12 flex flex-col gap-2 md:top-28">
      {views.length > 1 &&
        views.map((view, index) => {
          const isActive = currentView?.viewid === view.viewid;

          return (
            <button
              key={`solar-button-${index}`}
              onClick={() => setSelectedView(view)}
              className={`rounded-r-md bg-black bg-opacity-50 px-2 py-1 text-left text-xs text-white transition md:px-4 md:py-2 md:text-sm ${
                isActive ? 'scale-110 bg-green-400 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-blue-100'
              }`}
            >
              {view.viewname}
            </button>
          );
        })}
    </div>
  );
};
